import React, { useState, useEffect } from "react";
import '../../css/CssDoctorRegistration.css';
import favDocLogo from '../../assets/favdoctor logo 1.png';
import backGround from '../../assets/login-bg.png';
import m_background from '../../assets/mbil-service.png';
import crumb from '../../assets/crumbs3.png';
import check from '../../assets/ckeck.png'
import { useNavigate, Link } from "react-router-dom";
import { useStateValue } from "../../stateprovider";
import instance from '../../axios'
import Logo from '../../components/logo/Logo'
import '../land/land.css';
import LoginHeader from '../../components/Header/LoginHeader'



function UserRegistrationStep3() {
    const navigate = useNavigate();
    const [{ user }, dispatch] = useStateValue();
    const [bloodGroup, setBloodGroup] = useState("");
    const [genotype, setGenotype] = useState("");
    const [HIVStatus, setHIVStatus] = useState("");
    const [vaccination, setVaccination] = useState("");
    const [allergies, setAllergies] = useState("");
    const [disability, setDisability] = useState("");
    const [nextOfKinName, setNextOfKinName] = useState("");
    const [nextOfKinPhone, setNextOfKinPhone] = useState("");
    const [messages, setMessages] = useState("");
    const [processing, setProcessing] = useState(false);
    let date = new Date();
    let year = date.getFullYear();


    useEffect(()=>{
        if(user === null){
            navigate('/')
        }
    }, [user])
    const handleSubmit = async (e) => {
        e.preventDefault();
       // setProcessing(true)
        const formData = new FormData();
        formData.append("selectPicture", user?.picture);
        console.log(user?.picture)
       await instance.post('/uploadImage', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
          },
  
       })
        .then((res) => {
            if (res.data.error) {
                setMessages(res.data.error);
                setProcessing(false);
            } else {
       instance({
            method: 'post',
            headers: { "Content-Type": "application/json" },
            data: {
                user: user, bloodGroup: bloodGroup, genotype: genotype, HIVStatus: HIVStatus, vaccination: vaccination,
                allergies: allergies, disability: disability, nextOfKinName: nextOfKinName, nextOfKinPhone: nextOfKinPhone, picture: res.data.path
            },
            url: '/userRegistration'
        }).then(result => {
            if (result.data.result === "success") {
                dispatch({
                    type: "CREATE_USER",
                    user: {
                        user: user, bloodGroup: bloodGroup, genotype: genotype, HIVStatus: HIVStatus, vaccination: vaccination,
                        allergies: allergies, disability: disability, nextOfKinName: nextOfKinName, nextOfKinPhone: nextOfKinPhone, userId: result.data.userID
                    }
                });
                window.localStorage.setItem("userId", result.data.userID);
                window.localStorage.setItem("email", result.data.email);
                navigate('/thank-you', {options: "replace"});
            }
            else {
                setMessages(result.data.result);
            }
        }).catch(err => console.error(err))
        //             dispatch({
        //                 type: "CREATE_USER",
        //                 user: { user:user, bloodGroup: bloodGroup, genotype: genotype, HIVStatus: HIVStatus, vaccination: vaccination,
        //                      allergies: allergies, disability: disability, nextOfKinName:nextOfKinName, nextOfKinPhone:nextOfKinPhone}
        //             });

        //      history.replace('/thank-you');
    }}).catch(error => {
        setMessages(error.data.error);
        setProcessing(false);
    });


    }
    return (
                <div className="DocRegMain" >

                    <div className="DocRegMain__BackgroundImage">
                        <img src={backGround} alt="BackgroundImage" />
                        <img src={m_background} alt="BackgroundImage"/>

                    </div>
                    {/*<div className="DocRegMain__Header">
                  
                    <article className='favdoc__land-nav' style={{ zIndex: 20 }}>
                        <Logo />
                   
                    </article>
    </div>*/}
                    <LoginHeader />
                    <div className="UserRegMain__SignUpMedicalSection">
                        <div className="UserRegMain__SignUpMedicalForm">
                            <p>{messages}</p>
                            <form onSubmit={handleSubmit}>
                                <img src={crumb} alt="Crumbs" style={{ marginBottom: 25 + 'px' }} />
                                <div className="container rowDropDrown">
                                    <div className="row" style={{justifyContent: 'space-between' }}>
                                        <div className="col-12" style={{ alignItems: "left" }}>
                                            <p>Medical Profile</p>
                                        </div>
                                        <div className="col-4">
                                            <div className={bloodGroup ? "complete input-check active" : " active disabled input-check"} >

                                                <select name="bloodGroup" value={bloodGroup} onChange={(e) => setBloodGroup(e.target.value)}
                                                    required>
                                                    <option value="" aria-disabled="true">Blood Group</option>
                                                    <option value="A+">A+</option>
                                                    <option value="A-">A-</option>
                                                    <option value="B+">B+</option>
                                                    <option value="B-">B-</option>
                                                    <option value="AB">AB</option>
                                                    <option value="O+">O+</option>
                                                    <option value="O-">O-</option>
                                                    <option value="Unknown">Unknown</option>
                                                </select>
                                                    <img src={check} alt="" className={(bloodGroup.length > 1) ? "display" : "check"} style={{width: "fit-content"}}/>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className={genotype ? "complete input-check  active" : " active disabled input-check"}>

                                                <select name="genotype" value={genotype} onChange={(e) => setGenotype(e.target.value)} disabled={!bloodGroup}  required>
                                                    <option value="" aria-disabled="true">Genotype</option>
                                                    <option value="AA">AA</option>
                                                    <option value="AS">AS</option>
                                                    <option value="SS">SS</option>
                                                    <option value="AC">AC</option>
                                                    <option value="Unknown">Unknown</option>

                                                </select>
                                                    <img src={check} alt=""  className={(genotype.length > 1) ? "display" : "check"} style={{width: "fit-content"}}/>
                                                
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className={HIVStatus ? "complete input-check  active" : " active disabled input-check"}>
                                                <select name="HIV" value={HIVStatus} onChange={(e) => setHIVStatus(e.target.value)} disabled={!genotype}  required>
                                                    <option value="" aria-disabled="true">HIV Status</option>
                                                    <option value="Positive">Positive</option>
                                                    <option value="Negative">Negative</option>
                                                    <option value="Unknown">Unknown</option>
                                                </select>
                                                    <img src={check} alt="" className={(HIVStatus.length > 3) ? "display" : "check"} style={{width: "fit-content"}}/>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row" style={{justifyContent: 'space-between' }}>
                                        <div className="col-6">
                                            <div className={vaccination ? "complete input-check  active" : " active disabled input-check"} style={{ margin: 0 }}>
                                                <input type="text" placeholder="Vaccines" value={vaccination} onChange={(e) => setVaccination(e.target.value)} name="vaccinations" disabled={!HIVStatus}  multiple required />
                                                    <img src={check} alt="" className={(vaccination.length > 3) ? "display" : "check"} style={{width: "fit-content"}}/>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className={allergies ? "complete input-check  active" : " active disabled input-check"} style={{ margin: 0 }}>
                                                <input type="text" placeholder="Allergies" value={allergies} onChange={(e) => setAllergies(e.target.value)} name="Allergies" disabled={!vaccination}  multiple required />
                                                    <img src={check} alt="" className={(allergies.length > 3) ? "display" : "check"} style={{width: "fit-content"}}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className={disability ? "complete input-check  active" : " active disabled input-check"} style={{ margin: 0 }}>

                                                <input type="text" placeholder="Disabilities" value={disability} onChange={(e) => setDisability(e.target.value)} name="Disabilities" disabled={!allergies}  multiple required />
                                                    <img src={check} alt="" className={(disability.length > 3) ? "display" : "check"} style={{width: "fit-content"}}/>
                                            </div>
                                        </div>
                                        <div className="col-12">

                                        <button className={((disability.length < 2) || (processing === true)) ? "disabled_button not-allowed" : "button disabled_button"} disabled={(disability.length < 2) || (processing === true)}>Submit</button>
                                    </div>
                                    <p style={{
                                        marginBottom: 0, color: "#0F0F0F",
                                        fontWeight: 300, fontStyle: 'italic'
                                    }}>Already have an account?<Link to="/login">
                                            <span style={{ color: "#01B6E2", fontStyle: "normal", cursor: "pointer", textDecoration: "none", paddingLeft: 5 + 'px' }}>
                                                <b>Login</b></span></Link> </p>
                                    </div>


                                </div>
                             {/*</form>   <div className="container rowDropDrown">
                                    <div className="row">
                                        <div className="col-12" style={{ alignItems: "left" }}>
                                            <p>Next of Kin</p>
                                        </div>
                                        <div className="col-12">
                                            <div className={nextOfKinName ? "complete input-check  active" : " active disabled input-check"} style={{ margin: 0, marginBottom: 5 + '%' }}>

                                                <input type="text" placeholder="Full Name" value={nextOfKinName} onChange={(e) => setNextOfKinName(e.target.value)} name="fullName" disabled={!disability}
                                                     required />
                                                
                                                    <img src={check} alt="" className={(nextOfKinName.length > 3) ? "display" : "check"}/>
                                                
                                            </div>
                                        </div>
                                        <div className="col-12" >
                                            <div className={(nextOfKinPhone.length === 11) ? "complete input-check  active" : " active disabled input-check"} style={{ margin: 0 }}>

                                                <input type="number" placeholder="Phone Number" value={nextOfKinPhone} onChange={(e) => setNextOfKinPhone(e.target.value)} minLength="11" maxLength="11" name="phoneNumber"
                                                     required />
                                               
                                                    <img src={check} alt=""className={(nextOfKinPhone.length === 11) ? "display" : "check"} />
                                            </div>
</div>*/}
                                        {/*  <div className="col-12">
                        <div className="input-check">
                            <input type="password" placeholder="Password"  className={password ? "complete check-active  active" : " active disabled"} disabled={!nextOfKinPhone} value={password} onChange={(e)=> setPassword(e.target.value)}  name="Password" />
                            <div className={(password.length > 5) ? "check-active" : "check"}>
                            <img src={check} alt="" />
                    </div>
                            </div>
                        </div>
                            
                            <div className="col-12">
                            <div className="input-check">

                            <input type="password" placeholder="Confirm Password"  className={conPassword ? "complete check-active  active" : " active disabled"} disabled={!password} value={conPassword} onChange={(e)=>{
    
                                setConPassword(e.target.value);
                             
                               }}  name="Confirm Password" />
                               <div className={(conPassword.length > 5) ? "check-active" : "check"}>
                               <img src={check} alt="" />
                       </div>
                       </div>
                            </div>*/}

                                 {/*   </div>

                        </div>*/}
                              
                            </form>
                          
                        </div>

                    </div>


                    <div className="DocRegMain__Footer">
                        <div className="DocRegMain__Brand">
                            <p>&copy; {year} FavDoctor</p>
                        </div>
                    </div>



                </div>
    )
}

export default UserRegistrationStep3;